/// <amd-module name="SuiteCommerce.Blog.ExtCarousel.Indicator.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.ExtCarousel.Indicator.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ExtCarouselIndicatorModel = /** @class */ (function (_super) {
        __extends(ExtCarouselIndicatorModel, _super);
        function ExtCarouselIndicatorModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(ExtCarouselIndicatorModel.prototype, "index", {
            get: function () {
                return this.get('index');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ExtCarouselIndicatorModel.prototype, "slide", {
            get: function () {
                return this.get('slide');
            },
            enumerable: true,
            configurable: true
        });
        return ExtCarouselIndicatorModel;
    }(Backbone_1.Model));
    exports.ExtCarouselIndicatorModel = ExtCarouselIndicatorModel;
});
